export default __webpack_public_path__ + "static/media/gem-au-card.6ce6eccd.png";